export const CURRENT_STATUS = ['currentStatus'];
export const PREVIOUS_STATUS = ['previousStatus'];
export const AUDIT = ['auditParams'];